import * as i0 from "@angular/core";
var FacebookPixelEventTrackerService = /** @class */ (function () {
    function FacebookPixelEventTrackerService() {
    }
    FacebookPixelEventTrackerService.prototype.trackEvent = function (event, properties, custom) {
        if (custom === void 0) { custom = false; }
        if (typeof fbq === 'undefined') {
            return;
        }
        // console.log('Submitting facebook event:', event, properties);
        fbq(custom ? 'trackCustom' : 'track', event, properties);
    };
    FacebookPixelEventTrackerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FacebookPixelEventTrackerService_Factory() { return new FacebookPixelEventTrackerService(); }, token: FacebookPixelEventTrackerService, providedIn: "root" });
    return FacebookPixelEventTrackerService;
}());
export { FacebookPixelEventTrackerService };
